import Svg from '@doordash/component-svg'
import * as React from 'react'

// tslint:disable:max-line-length
export const ReadyToDash: React.FunctionComponent = () => (
  <Svg
    width={325}
    height={280}
    fill="none"
    viewBox="0 0 375.1 324"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <style>
      {
        '.prefix__st1{fill:#9b7d75}.prefix__st2{fill:#e6e5d7}.prefix__st4{fill:none;stroke:#c7c6b7;stroke-width:.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.prefix__st6{fill:#e5bbb7}.prefix__st7{fill:#ff3008}.prefix__st8{fill:#ff4f2d}.prefix__st10{fill:#fff}.prefix__st11{fill:#c7c6b7}.prefix__st15{fill:#4e6659}.prefix__st20{fill:#a98a80}.prefix__st21{fill:red}.prefix__st22{fill:#f7e3e1}.prefix__st23{fill:#28362c}.prefix__st25{fill:#e2f3f7}.prefix__st26{fill:#3c5749}.prefix__st27{fill:#9ca9a2}.prefix__st28,.prefix__st29{opacity:.5;fill:#c0e2e9}.prefix__st29{fill:#3c5749}'
      }
    </style>
    <path
      d="M312.2 286.9c18.6-12 33.2-37.9 42.6-71.8 9.8-35.4-2.4-57.9-33.3-61.2-30.8-3.3-23.1-23.4-21.2-41 1.9-17.6 6.3-35.6-8.1-57.4C275 29 228.2 18.8 192.5 66s-63.8 42.6-97.1 37.2c-17.3-2.8-52.6-13.8-70.5 18.6-35.9 65.3 67.9 165.1 67.9 165.1s192.8 2.6 219.4 0z"
      fill="#e5f3f7"
    />
    <path
      className="prefix__st1"
      d="M124.8 152.9c-2.9 4.2-6.2 12.2-5 16.8s4.7 12.6 8.9 12.7c51 1.8 65.1-5.5 67.3-3 .7.8-2.1 6.9 1 17.4 6.7 23.2 6.5 37 6.6 39.6.1 1.4 12.1 2.3 10.3-.6-1.9-3.1-.7-43.4-.8-52-.2-16.3-3.7-21.2-10.4-23-4.9-1.3-38.2-1.9-45.4-2.7-7.2-.7-32.5-5.2-32.5-5.2z"
    />
    <path
      className="prefix__st2"
      d="M215.3 234.8c-.8-1-1.9-2.3-2.4-1.9s-1.5 2.3-1.5 3.1c-.1.8 1.7 0 2.4-.3s1.5-.9 1.5-.9zm19.7 11.1c.2.9.1 1.8-.8 2.2-.6.2-6.5.9-11 1-4.5.1-17.6.4-19 .4-1.7 0-3.5-.1-3.9-.6-.7-.9.5-4.8.5-4.8s9.9.9 15.7.9 13.7.6 15.6.3 2.3-.4 2.3-.4.5.2.6 1z"
    />
    <path
      d="M234.4 244.8s-.3-1.4-1.4-1.7c-1.1-.4-6.5-2-11.8-5.1-2.6-1.5-5.4-3.1-6.1-3.6-.8-.4-3.4 1.9-3.7 2.2-.3.3-2 .8-3.2.8-1.1 0-1.6-.1-2.1-.6s-.2-2.6-1.3-2.6-2 .3-2.2.7-1.1 3.5-1.2 4.8-.5 4-.5 4.1 3.4.9 10.4 1.1c6.2.2 17.2.4 19.2.3 2.7 0 3.9-.4 3.9-.4z"
      fill="#f4f3ed"
    />
    <path
      className="prefix__st4"
      d="M217.5 235.3s-.1.9-1 1.5m3-.4s-.1 1.3-.8 1.8m2.8-.8s0 1.2-.6 2.1m2.6-.8s0 1.2-.6 2.1m2.6-.6s.2.7-.4 1.5"
    />
    <path
      d="M150.7 155.2s10.9.1 23.8 1.1c12.8 1 18.5 1.5 18.6 1.8.2 1.1-.3 4.5-2.7 6.8-2.3 2.3-36.1-3.1-37.6-4.4-1.3-1.3-2.1-5.3-2.1-5.3z"
      fill="#95bfc4"
    />
    <path
      className="prefix__st1"
      d="M169.7 125c5.3 1.1 17.8 4.9 20 5.6 6.7 1.9 27.5 5.9 28.9 5.7.9-.1 2.7 1 3 4.6.1 1.2.2 3.8-1.5 3.4-1.4-.3-4.8-.1-5.9-.2-2.5-.1-1.9.2-9.9-.3-10-.6-25.3-1.3-39.7-4.4-1-.2-2.8-1.9-3.8-4.4-.9-2.3.7-1.9 1.6-4.9 1.3-4.7 7.3-5.1 7.3-5.1z"
    />
    <path
      className="prefix__st1"
      d="M141 97c.7 3.3 15.6 31 18.7 37.3 0 0 3.6 7.9 10.4 4.5 6.7-3.3.8-15.4.8-15.4-2.3-6.8-6.7-15.1-6.5-14.5L154.7 93s-10.1-1.1-13.7 4zm76.7 39.3s5.3-2.3 8.2-2.1c2.9.3 11.6 5.2 11.1 7-.4 1.4-4.1-.3-4.7-.9-.6-.6-.4 2.9-1.3 3.8s-2.7 1.4-2.8.9c-.3-1.2.1-4.8-1-5.7-1.2-.9-3.4-1.4-4.6 1-1.2 2.3.6 3.9 1.5 4.2.9.3 3.7-.1 4.1 1 .3 1 .3 1.1-.3 1.2-.6.2-2.5.1-3.6.2s-2 .4-3.2-.1c-1.2-.6-4.5-3.1-4.5-3.1l1.1-7.4z"
    />
    <path
      className="prefix__st6"
      d="M163.4 121.2s5.8-4 6.7-5.5c.8-1.5-6.2-15.3-7-16.6-.8-1.3-6.7 6.3-6.5 10.6.2 4.4 6.8 11.5 6.8 11.5z"
    />
    <path
      className="prefix__st7"
      d="M95.7 79.3c-.3.6-15 66.9-13.6 67.6 2.1 1.2 9.5 3.4 17.8 5.1 9.1 1.8 18.8 2.9 19.2 2.4.9-1 15.7-68.3 15.7-68.3l-39.1-6.8z"
    />
    <path
      className="prefix__st8"
      d="M94.1 127.2c.5.4 21.2 4.6 21.7 3.9.5-.6 5.5-28.4 5.5-28.4s-21.7-2.9-21.7-2.4c-.1.4-6 26.6-5.5 26.9z"
    />
    <path
      d="M100.3 96.2c-.1.9-3.4 7.5-.6 8.8 2.8 1.3 16.5 3.6 18.1 3.5 1.6-.1 2.7.1 3.4-2 .7-2.1 1.6-5.8 1.6-5.8l-22.5-4.5z"
      fill="#ff5d3e"
    />
    <path
      className="prefix__st10"
      d="M100.4 112c.3 1 0 1.5.6 2.4.6.9.9 1.4 1.3 1.5.4.1 3.2.4 4.8.7 1.6.3 2.9.6 2.9 1.3 0 .8-.1 1.2-1.3 1.1-1.2-.1-3.6-.7-4-.7-.5.1-2-.4-1.4.5.6.9 1.8 3 2.3 3.1.8.1 3.6.6 4.6.8 1.7.2 3.7-2.3 3.9-3.7.2-1.4-.7-4.1-2.2-4.5-1.5-.5-6.1-1.4-7.1-1.6-1.2-.4-4.4-.9-4.4-.9z"
    />
    <path
      className="prefix__st8"
      d="M95.7 76.9c-.5.5-2 4.4-1.2 7.2.5 1.7 2 2.5 4.4 3.2 6.5 1.8 29.2 5.2 32.7 6.2 3.6 1 6.1-4.1 6.6-6.1l.5-2s-42.2-9.4-43-8.5z"
    />
    <path
      className="prefix__st11"
      d="M235.8 138.1c-.1-.1-6-12.1-7.7-16.8-1.7-4.5-7.3-4.1-7.3-4.1v-.4c.1 0 5.9-.5 7.7 4.3 1.7 4.7 7.6 16.6 7.7 16.8l-.4.2z"
    />
    <path
      className="prefix__st11"
      d="M217.4 106.2c1.4-2 4.4 3.1 4.5 6.6s-.3 5.5-2.4 8.2c-1.6 2-1.9 1.8-2.4 1.9-2.1.4-1.1-14.7.3-16.7z"
    />
    <path
      d="M248.4 134.9s3.2 1.7 4 7.2c.9 7-2.8 10.5-2.8 10.5l-1.2-17.7z"
      fill="#fcf79b"
    />
    <path
      d="M201 237.9c-.9-1.2-2.1-2.9-2.8-2.4-.6.5-1.9 2.8-2 3.7-.1.9 2 .1 2.9-.2 1-.4 1.9-1.1 1.9-1.1zm23.3 14.5c.2 1.1 0 2.2-1.1 2.6-.7.3-7.9.8-13.4.7-5.5-.1-21.3-.4-22.9-.5-2-.1-4.2-.3-4.6-.9-.8-1.1.9-5.9.9-5.9s11.9 1.6 18.9 1.9c6.9.3 16.5 1.4 18.8 1.2 2.3-.2 2.8-.4 2.8-.4s.5.3.6 1.3zm-20.6-13.8s-.2 1.1-1.2 1.8m3.6-.4s-.2 1.6-1 2.2m3.3-.8s-.1 1.5-.8 2.5m3.2-.9s-.1 1.5-.8 2.5m3.1-.6s.2.8-.6 1.9"
      fill="#a9d7e0"
    />
    <path
      d="M64.2 217.1c-2.2 0-14.4-1.4-15.8 2.9s0 14.4 2.9 16.5c2.9 2.1 12.9-19.4 12.9-19.4z"
      fill="#ff4926"
    />
    <path
      className="prefix__st15"
      d="M263.7 219.2c-5.1 7.2-13.5 22.6-21 30.4-7.8 8.2-18.9 18.3-30.2 18.7-8.2.3-27.2.2-39.5-.2-4.5-.2-25-1.1-31.8-7-6.8-5.9 14.9-28.3-6.1-42-20.5-13.4-31.5-16.2-31.5-16.2l13.8-6.9 63.7 6.5s-16.6 20.4-6.9 33.7c6.4 8.7 11.6 7.6 21 9.8 9.4 2.2 18.1 2.9 25.4-3.6 7.2-6.5 19.9-24.6 22.1-32.6"
    />
    <path fill="#d8edf1" d="M115.4 243.5l-20.3-3.7.3-1.2 21.8 2.5z" />
    <path
      d="M112.3 198.9s-.8-9.4 1.4-12.3 4.8-4.3 9.1-4.3 32.5.5 36.5-.1c6-.8 19.3 2.2 21.8 3.3 2.5 1.1 4.7 12 4 13.4-.7 1.4-4 3.6-4 3.6l-68.8-3.6z"
      fill="#3b5748"
    />
    <path
      d="M112.3 198.9s-.8-9.4 1.4-12.3 4.8-4.3 9.1-4.3 32.5.5 36.5-.1c6-.8 19.3 2.2 21.8 3.3 2.5 1.1 4.7 12 4 13.4-.7 1.4-4 3.6-4 3.6l-68.8-3.6z"
      fill="#7c4c32"
    />
    <path className="prefix__st11" d="M55.9 286.8h248.6v.4H55.9z" />
    <path
      fill="none"
      stroke="#c7c6b7"
      strokeWidth={0.4}
      strokeMiterlimit={10}
      d="M310.6 287h33.5"
    />
    <path className="prefix__st11" d="M31.2 286.8h18v.4h-18z" />
    <path
      className="prefix__st20"
      d="M121.9 151.7c-3.1 4.1-6.7 12-5.7 16.6 1 4.6 4.2 12.8 8.3 13.1 50.9 3.8 65.3-2.9 67.4-.4.7.8-2.3 6.8.3 17.5 5.8 23.5 5 37.3 5.1 39.9.1 1.4 12 2.8 10.3-.2-1.8-3.1 1-43.4 1.2-52 .4-16.3-2.8-21.4-9.5-23.4-4.8-1.5-38.1-3.4-45.3-4.5-7-1-32.1-6.6-32.1-6.6zm38-81c-1.9 2.3-1.8 6.1-1.9 7.9-.3 5.5 3.1 10.2 3.1 10.2s0-.5-4.2-1.5c-4.1-1-12.3-3.6-12.3-3.6s2.5-6.1 3.3-8.4c3.3-8.5.5-16.5.6-17.3.1-.8 6.6 3 6.6 3l2.7 9.4 2.1.3z"
    />
    <path
      className="prefix__st20"
      d="M170.4 45.9c1 1.1 2.4 5.5 1.6 10.2-.7 4.2 1.9 7.1 2.2 8 .3 1-2.2.8-2.2.8s-.8 3.8-1.3 5.4c-.5 1.6-1.1 3.6-3.5 3.6-1.8 0-8.8 0-10.8-4.7-2.1-4.7-3.7-12.1-1.2-15.6 2.6-3.6 13.6-9.4 15.2-7.7z"
    />
    <path
      className="prefix__st21"
      d="M171.6 63.2c-.4 0-.8-.3-1-1.5-.1-.8-.1-1.8 0-2.9.1-1.1.4-2.1.7-2.8.5-1.1.9-1.2 1.2-1.2.3 0 .7.3.9 1.5.1.8.1 1.8 0 2.9-.1 2-.9 4-1.8 4zm1-7.9c-.1 0-.4.2-.7.9-.3.7-.6 1.6-.7 2.7-.1 1-.1 2 0 2.8.1.8.4 1 .5 1.1.3.1 1.1-1.2 1.4-3.6.1-1 .1-2 0-2.8-.2-.8-.4-1.1-.5-1.1z"
    />
    <path
      transform="matrix(.06457 -.9979 .9979 .06457 94.189 216.463)"
      className="prefix__st21"
      d="M162.3 49.7h.5v16.6h-.5z"
    />
    <path
      className="prefix__st22"
      d="M159.1 84s4 7.7 6.8 14.9c3.2 8 1.9 14.6-2.4 17.1-6.2 9.5-12.8 32.7-12.8 32.7l-30.3 2.8-.7-7.9s2.7-30.9 9.8-45.7c5.4-11.3 15.3-18.5 16.8-18.7 3.8-.3 12.8 4.8 12.8 4.8z"
    />
    <path
      className="prefix__st23"
      d="M143.2 61.6c-7.8 4.6-6.4-22.2-31.8-13.4-11.5 4-22.3 4.3-27.9-2.6-8.4-10.4-10.1 18.7 1.8 28.5 10.2 8.4 19.4 2.3 30.9-3.4s15 2.8 23.1 4.9c13.1 3.4 23-8 17.7-22.6-1.7-4.3.1.3-13.8 8.6z"
    />
    <path
      d="M190.6 161s-20.9-1.1-33.9-3.1c-2.7-.4-5-1.4-5-1.4l-.3-10.2-29.1-1.6-6.5 13.5c-2.6 13.3-1.5 28.1 16 29.5 14.9 1.2 51.1-1.6 52.6-1.7 1.8-1.2 5-12.3 6-16.8.6-8 .2-8.2.2-8.2z"
      fill="#a6c7ce"
    />
    <path
      className="prefix__st25"
      d="M136.2 164.6c-3.1 0-12.4-3.8-14.8-4.8l.2-.4c4.3 1.9 13.4 5.3 15.1 4.7 6.4-2.2 13.7-9.2 14.4-10l.3.3c-.7.9-8 7.8-14.5 10.1-.2 0-.5.1-.7.1z"
    />
    <path
      className="prefix__st20"
      d="M165.2 127.7c5.3 1.1 17.8 4.9 20 5.6 6.7 1.9 27.5 5.9 28.9 5.7.9-.1 2.7 1 3 4.6.1 1.2.2 3.8-1.5 3.4-1.4-.3-4.8-.1-5.9-.2-2.5-.1-1.9.2-9.9-.3-10-.6-25.3-1.3-39.7-4.4-1-.2-2.8-1.9-3.8-4.4-.9-2.3.7-1.9 1.6-4.9 1.3-4.7 7.3-5.1 7.3-5.1z"
    />
    <path
      className="prefix__st26"
      d="M94.7 63h-.5c-3.9-.1-7-1.4-9.2-3.9-4.7-5.2-4-13.9-4-14h.4c0 .1-.7 8.6 3.9 13.7 2.2 2.4 5.2 3.7 8.9 3.8 5.3.1 10-2.1 14.6-4.3 7.6-3.6 14.7-7 22.7 2.2l-.3.3c-7.8-8.9-14.5-5.8-22.2-2.1-4.4 2.1-9 4.3-14.3 4.3z"
    />
    <path
      className="prefix__st23"
      d="M250.3 249.8c-1.5 2.2-2.1 14.7 2.4 22.6 4.5 7.8 13.1 15.7 28.4 15.5 15.5-.2 22.9-7.6 28-17.9 6.1-12.5 1.9-26.1-4.5-34.3-6.3-8.2-18.1-12.7-32.8-8.2-17.3 5.1-21.5 22.3-21.5 22.3z"
    />
    <path
      className="prefix__st2"
      d="M266.7 250.7c-.6 1.8-1.5 5 .1 9.8 1.7 4.8 7 9.2 14.1 9.1 7.1-.1 11.8-4.2 13-9.9 1.3-5.7-1.1-13-4.9-16-3.8-2.9-10.2-3.9-15.5-1.1-5.3 2.8-6.8 8.1-6.8 8.1z"
    />
    <path
      className="prefix__st23"
      d="M63.5 248.8c-1.5 2.2-2.1 14.7 2.4 22.6S79 287 94.3 286.8c15.5-.2 22.9-7.6 28-17.9 6.1-12.5 1.9-26.1-4.5-34.3s-18.1-12.7-32.8-8.2c-17.3 5.2-21.5 22.4-21.5 22.4z"
    />
    <path
      className="prefix__st2"
      d="M80.3 248.8c-.6 1.8-1.5 5 .1 9.8 1.7 4.8 7 9.2 14.1 9.1 7.1-.1 11.8-4.2 13-9.9 1.3-5.7-1.1-13-4.9-16-3.8-2.9-10.2-3.9-15.5-1.1s-6.8 8.1-6.8 8.1z"
    />
    <path
      className="prefix__st15"
      d="M232.3 155.9s-4.2.5-3.3 6.5c.9 6.1 8.1 27.1 7.5 45-.7 18.4-6.1 23.5-13.1 31.9-7 8.4-9.8 10.3-9.8 10.3s9.3 1.9 18.2-3.7c8.9-5.6 52.7-26.3 52.7-26.3s6.1-19.1-19.3-34.5c-19.3-11.7-27.7-28.2-28.2-30.5-2.8.8-4.7 1.3-4.7 1.3z"
    />
    <path
      className="prefix__st15"
      d="M224.6 147.3c.3-.1 2.8.1 4.1 1.3s2.8 3.6 3.6 8.2c3-.2 4.7-2.2 4.7-2.2s-.3-.1 2 0 9.3-.4 10.4-1.6 1.4-12.8-1.9-19.3c-2.7-.9-7.7-.8-12.9 3.3s-6.4 5.7-7.8 6.2-3.6.8-3.6.8l1.4 3.3zm20.3 123.4s-8.4-23.3 2-39c9.4-14.1 27.7-19.7 41.7-15.2 14 4.5 24.2 17.2 23.2 20.7s-6 5-12 5-15.3-4.4-24.9.9c-8.2 4.4-5.6 10.1-9.1 17.1-3.4 7-9.9 13-20.9 10.5zM46.4 242c-2-2.6 16.5-32.3 41.8-37.5 12.9-2.7 24.5-3.4 34.8.5 19.6 7.5 28.9 29.9 28 44.3-.4 6.9-1.4 12.6-1.4 12.6s-37.8.9-74.1-8.9c-8.9-2.3-27.1-8.4-29.1-11z"
    />
    <path
      className="prefix__st27"
      d="M225.2 249.1l-.3-.4c7.2-6.5 19.2-20.8 18.4-43.4-.5-15.5-4.1-25.2-6.7-32.3-1.1-2.9-2-5.3-2.5-7.7-2-8.4 2.4-11.2 2.5-11.3l.3.4s-4.2 2.8-2.3 10.8c.5 2.3 1.5 4.8 2.5 7.6 2.6 7.1 6.3 16.9 6.8 32.5.7 22.8-11.4 37.2-18.7 43.8zm-109.9 3c-9.7-.3-20.2-2.1-20.3-2.1l.1-.5c.1 0 10.6 1.8 20.3 2.1l-.1.5zm1-4.2c-9.7-.3-20.2-2.1-20.3-2.1l.1-.5c.1 0 10.6 1.8 20.2 2.1v.5zm1.1-4.6c-9.7-.3-20.2-2.1-20.3-2.1l.1-.5c.1 0 10.6 1.8 20.3 2.1l-.1.5z"
    />
    <path
      className="prefix__st23"
      d="M149.6 68.9c3.7-1.4-1.5-3.6-3.1-5.8-.7-1-2.4-3.4-.2-4.8 2.2-1.4 2.7-1.3 4.5-4.1s2-10.8 6.3-13c7.9-4 16.9-.5 16.7 4.6-.1 2.2.2 7.7-8.7 9.5-3.4.7-6.6-2.5-5.9 6.7.5 6.5-4.3 8.5-7.1 9.1"
    />
    <path
      className="prefix__st2"
      d="M175.4 47c0-2.6-2.6-9.1-8.1-11.9-6.2-3.2-11.6-5.2-21-1.1-9.6 4.2-11.8 13.6-10.9 19s4.7 13.3 4.7 13.3 6.5 1.5 8.8 1.7c2.3.2 4.4.2 6.5-2.2 2.1-2.4 1.9-3.9 1.7-7.7s.7-5.6 2.6-7.2c1.6-1.4 3.3-2 7-2.3 3.7-.2 8.7 0 8.7-1.6z"
    />
    <path
      className="prefix__st27"
      d="M244.4 270.6c-.1-.2-8.6-24.3 2.1-40.4 9.2-14 27.8-20.8 43.3-15.8 14.9 4.8 23.1 15.9 24.1 20.8l-.5.1c-1-4.8-9-15.7-23.8-20.4-15.2-4.9-33.6 1.8-42.7 15.6-10.5 15.9-2.1 39.7-2 39.9l-.5.2z"
    />
    <path
      className="prefix__st25"
      d="M158.2 182c-13.9 0-25.2-.9-25.4-.9v-.4c.3 0 25.8 2.1 47.2 0v.4c-7.2.6-14.8.9-21.8.9z"
    />
    <path
      className="prefix__st23"
      d="M150.6 72.6c-2.3 0-5.1-.5-8.2-1.4l.1-.4c6.7 2 11.4 1.9 14-.4 3.1-2.6 2.4-7.5 2.1-9.3l.4-.1c.3 1.9 1 6.9-2.3 9.7-1.4 1.3-3.4 1.9-6.1 1.9z"
    />
    <path
      className="prefix__st28"
      d="M151.4 146.8v-.4l-31.2-1.4h2c-.1.9-2.2 1.7-2.2 1.7l-.5 5.1 31.2-3c0-.1.3-.8.7-2z"
    />
    <path
      className="prefix__st27"
      d="M246.8 153.6l-.5-.1c1.8-10.7-1.8-18-1.8-18l.4-.2s3.8 7.4 1.9 18.3z"
    />
    <path
      className="prefix__st29"
      d="M246.9 231.7c-1.7 2.5-2.8 5.2-3.7 8 16-8.2 41.3-20.2 41.3-20.2s.5-1.5.6-3.9c-13.4-2.7-29.6 3.1-38.2 16.1zM149.6 262s1-5.7 1.4-12.6c.9-14.5-8.4-36.8-28-44.3-5.7-2.2-11.8-2.9-18.3-2.7l-1.1.5s11 2.8 31.5 16.2c20.9 13.7-.7 36 6.1 42l1.2.9h7.2z"
    />
    <path
      className="prefix__st27"
      d="M47.3 242.5l-.5-.1c.1-.2 8.1-25.1 36.2-34.1 13.7-4.4 25.8-4.1 36 .9 9.5 4.6 16.9 13.1 22 25.1l-.5.2c-5.1-11.9-12.4-20.3-21.8-24.9-10.1-4.9-22.1-5.2-35.6-.9-27.8 9-35.7 33.5-35.8 33.8z"
    />
    <path
      className="prefix__st25"
      d="M180.5 185.3l-.4-.2c5.9-11.7 5.8-24.1 5.7-24.2h.4c.1.1.2 12.6-5.7 24.4z"
    />
    <path
      className="prefix__st29"
      d="M173.9 235.6s2 19.3 21.5 18.2 22.6-9.5 22.6-9.5-14.2 3-30.1.2c-8.4-1.4-10.5-4.7-14-8.9z"
    />
    <path
      className="prefix__st2"
      d="M209.1 237.2c-.7-1-1.8-2.3-2.3-2s-1.6 2.3-1.7 3 1.7.1 2.4-.2 1.6-.8 1.6-.8zm19.2 11.8c.1.9 0 1.8-.9 2.1-.6.2-6.5.6-11 .5-4.5-.1-17.6-.3-19-.4-1.7-.1-3.4-.2-3.8-.8-.7-.9.7-4.8.7-4.8s9.9 1.3 15.6 1.6c5.7.3 13.7 1.1 15.6.9 1.9-.2 2.3-.3 2.3-.3s.4.4.5 1.2z"
    />
    <path
      className="prefix__st10"
      d="M227.7 247.9s-.2-1.4-1.3-1.8-6.5-2.3-11.6-5.5c-2.5-1.6-5.2-3.3-6-3.8-.7-.5-3.5 1.8-3.8 2.1-.3.3-2.1.7-3.2.7s-1.6-.2-2.1-.7c-.5-.5-.1-2.6-1.2-2.6-1.1 0-2 .3-2.2.6-.2.4-1.2 3.5-1.4 4.8-.2 1.3-.7 4-.7 4.1 0 .2 3.4 1.1 10.3 1.5 6.2.4 17.2 1.1 19.2 1.1 2.8-.1 4-.5 4-.5z"
    />
    <path
      className="prefix__st4"
      d="M211.2 237.8s-.1.9-1 1.5m3-.4s-.2 1.3-.8 1.8m2.7-.6s-.1 1.2-.7 2.1m2.7-.8s-.1 1.2-.7 2.1m2.6-.6s.1.7-.5 1.5"
    />
    <path
      className="prefix__st7"
      d="M123 105.7s20.2-11.7 30-8.9c-.6-3.1-5.9-6.2-10.6-6.5-6.4-.4-11.8 3.5-15.2 8.4-.8 1.3-4.2 7-4.2 7zm34.5 18.3s-25.2 15.2-26.3 16.4c-1.8 1.9-.1 6.8 1.3 6.9 1.4.1 23.6-13.6 23.6-13.6l-.3-5.5 1.7-4.2z"
    />
    <path fill="#63796d" d="M134.7 140.9l-15.7 3.6.5 4.6 15.6-5.3z" />
    <path
      className="prefix__st20"
      d="M136.5 99.7c.7 3.3 15.6 31 18.7 37.3 0 0 3.6 7.9 10.4 4.5 6.7-3.3.8-15.4.8-15.4-2.3-6.8-6.7-15.1-6.5-14.5l-9.6-15.9c-.1 0-10.2-1.1-13.8 4z"
    />
    <path
      className="prefix__st22"
      d="M153.7 94.8c2.7 4.1 8.4 12.9 10.2 15.3-1.2 3.5-6.9 8.5-17.7 13.9-8.1-9.5-9.9-17.6-10.1-22.5-.2-3.8 1.4-7.5 4.5-9.7 1.9-1.3 4.4-2.2 7.5-1.3 2.3.6 4.2 2.3 5.6 4.3z"
    />
    <path
      className="prefix__st10"
      d="M147.7 123.3l-.2-.4c13.1-6.7 15.8-12.1 16.1-12.9-1.9-2.5-7.7-11.4-10.1-15.2-1.4-2.1-3.3-3.6-5.5-4.3l.1-.4c2.3.7 4.3 2.3 5.8 4.4 2.5 3.8 8.4 12.9 10.2 15.3l.1.1v.1c-.2.4-2.3 6-16.5 13.3z"
    />
    <path
      className="prefix__st23"
      d="M224.9 144.7c0 1.3-.5 2.3-1.3 3.2-.7.7-1.8 1.1-2.7.9-1.5-.3-2.3.3-3.5-1.9-.4-.8-.6-1.8-.4-2.7.3-1.1.9-2 1.8-2.7 1.8-1.5 4.6-.9 5.6 1.2.3.6.5 1.3.5 2"
    />
    <path
      className="prefix__st20"
      d="M213.2 139.1s5.3-2.3 8.2-2.1c2.9.3 11.6 5.2 11.1 7-.4 1.4-4.1-.3-4.7-.9-.6-.6-.4 2.9-1.3 3.8s-2.7 1.4-2.8.9c-.3-1.2.1-4.8-1-5.7-1.2-.9-3.4-1.4-4.6 1-1.2 2.3.6 3.9 1.5 4.2.9.3 3.7-.1 4.1 1 .3 1 .3 1.1-.3 1.2s-2.5.1-3.6.2-2 .4-3.2-.1c-1.2-.6-4.5-3.1-4.5-3.1l1.1-7.4z"
    />
    <path
      className="prefix__st26"
      d="M211.1 137.6l-.9 10.5-5.4-.5s1.6-10.3 2-10.4c.3-.1 4.3.4 4.3.4z"
    />
    <path
      className="prefix__st10"
      d="M209.9 139c.8.6 1.5 1.3 1.6 1.9.2.7.3 2.1-.3 3-.7 1-2.3 2-3.3 1.9s-2.4-.8-2.8-1.5c-.4-.7-.7-1.5-.7-2.4.1-.9.2-1.7 1.5-2.8 1-.8 2.6-.7 3-.6l1 .5z"
    />
    <path
      fill="none"
      stroke="#e6e5d7"
      strokeWidth={0.4}
      strokeMiterlimit={10}
      d="M208.4 143.9l-.9-2.1 3.4-1.3"
    />
    <path
      className="prefix__st27"
      d="M114.5 222.2c-3.4 0-12.1-3.2-15.9-4.8-.1-.1-.3-.2-.4-.4-.6-1.9 4.8-10 5.4-10.9l.4.3c-2.3 3.5-5.7 9.2-5.3 10.5 0 .1.1.1.1.1 4.6 1.9 14.2 5.3 16.4 4.7 1.8-.6 6.1-7.2 7.5-9.7l.4.3c-.2.4-5.4 9.2-7.8 9.9h-.8z"
    />
    <path
      className="prefix__st26"
      d="M95.3 80.4c-1.8 0-3.5-.4-5-1.2-8.6-4.4-10.4-19.6-10.4-19.7h.4c0 .2 1.8 15.1 10.2 19.4 3.9 2 8.6 1.4 14-1.7 3.6-2.1 6.7-4.2 9.3-6.1 5.2-3.6 8.9-6.3 12.8-5.5 3.2.6 6.4 3.4 10.3 9.2l-.3.2c-3.8-5.7-6.9-8.5-10-9.1-3.7-.7-7.4 1.9-12.5 5.5-2.7 1.9-5.7 4-9.4 6.1-3.4 1.9-6.5 2.9-9.4 2.9z"
    />
    <path
      className="prefix__st11"
      d="M156.9 53c-1.6-4.4.3.3-13.7 8.6-2.8 1.7-4.5-.8-6.6-4.2 1.4 4.5 3.5 8.8 3.5 8.8s6.5 1.5 8.8 1.7c2.3.2 4.4.2 6.5-2.2 2.1-2.4 1.9-3.9 1.7-7.7-.1-1.5 0-2.7.3-3.6-.2-.4-.4-.9-.5-1.4z"
    />
    <path
      className="prefix__st23"
      d="M152.4 64.2c-.5 1-1.5 1.3-2.6.8s-1.2-1.7-.7-2.7 1.5-1.4 2.6-.9c1.1.5 1.2 1.8.7 2.8z"
    />
    <g>
      <path
        className="prefix__st6"
        d="M161.1 88.7c0 .1 0 .1 0 0 0 .1 0 .1 0 0zm-14.6-9.5c-.9 2.3-1.8 4.5-1.8 4.5s8.1 2.6 12.3 3.6c3.2.8 4 1.2 4.1 1.4-.3-.4-1.5-2.3-2.3-4.9-1.8-1-8.9-4.7-12.3-4.6z"
      />
    </g>
    <g>
      <path
        className="prefix__st28"
        d="M181.1 185.5c-2.5-1.1-15.8-4.1-21.8-3.3-4 .5-32.2.1-36.5.1-1.2 0-2.3.1-3.3.4 2.6 2.8 6.6 4.7 12.3 5.1 12.9 1 41.6-.9 50.2-1.6-.4-.3-.6-.6-.9-.7z"
      />
    </g>
  </Svg>
)

export default ReadyToDash
